import React from 'react';
import { Link } from 'react-router-dom';
import { products } from '../mock/mock';
import { Heart, Car, Bike, ShieldCheck, ArrowRight, Shield, Briefcase } from 'lucide-react';

const iconMap = { Heart, Car, Bike, ShieldCheck, Briefcase };

const productLinks = {
  Health: '/insurance/health',
  Car: '/insurance/car',
  Bike: '/insurance/bike',
  Life: '/insurance/life',
  Term: '/insurance/term',
  'Group Term': '/products/group-term',
  'Group Health': '/products/group-health',
  'Personal Accident': '/products/personal-accident',
  Home: '/products/home-insurance',
  'Workmen Compensation': '/products/workmen-compensation',
  'Fire & Burglary': '/products/fire-burglary',
  Marine: '/products/marine-insurance',
  'HDFC Life': '/products/hdfc-life',
  'Care Health': '/products/care-health',
};

const moreProducts = [
  { name: 'Term', icon: Shield, color: 'text-teal-600', bg: 'bg-teal-50', to: '/insurance/term' },
  { name: 'Group Health', icon: Heart, color: 'text-emerald-600', bg: 'bg-emerald-50', to: '/products/group-health' },
  { name: 'Home', icon: Shield, color: 'text-slate-600', bg: 'bg-slate-100', to: '/products/home-insurance' },
  { name: 'Marine', icon: Briefcase, color: 'text-sky-600', bg: 'bg-sky-50', to: '/products/marine-insurance' },
];

const otherProducts = [
  { name: 'Sattva Products - Organic Mangoes', subtitle: 'Fresh farm-picked mangoes', icon: Shield, color: 'text-amber-600', bg: 'bg-amber-50', to: '/products/sattva-organic-mangoes' },
];

const Products = () => {
  return (
    <section className="bg-gradient-to-b from-slate-50 to-white py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0F2A4B] max-w-3xl mx-auto leading-tight">
            Explore our insurance products.<br />
            <span className="text-[#00B48E]">Get instant quotes today.</span>
          </h2>
          <p className="mt-4 text-slate-600 text-lg">We cover what matters the most to you — from life, health, motor, and beyond.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">
          {products.map((p) => {
            const Icon = iconMap[p.icon];
            return (
              <Link to={productLinks[p.name] || '/'} key={p.name} className={`group relative rounded-3xl bg-gradient-to-br ${p.color} border border-slate-100 p-7 cursor-pointer hover:-translate-y-1 hover:shadow-xl transition-all block`}>
                <div className={`w-16 h-16 rounded-2xl bg-white flex items-center justify-center shadow-sm mb-6 ${p.iconColor} group-hover:scale-110 transition-transform`}>
                  <Icon className="w-8 h-8" strokeWidth={1.8} />
                </div>
                <div className="text-2xl font-bold text-[#0F2A4B]">{p.name}</div>
                <div className="text-xl text-slate-700">{p.subtitle}</div>
                <div className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#00B48E] group-hover:gap-3 transition-all">
                  Get Quote <ArrowRight className="w-4 h-4" />
                </div>
              </Link>
            );
          })}
        </div>

        <div className="mt-10">
          <div className="text-center text-sm font-medium text-slate-500 uppercase tracking-wider mb-5">More Products</div>
          <div className="flex flex-wrap justify-center gap-4">
            {moreProducts.map((p) => {
              const Icon = p.icon;
              return (
                <Link to={p.to} key={p.name} className={`flex items-center gap-3 ${p.bg} rounded-full pl-2 pr-5 py-2 border border-slate-100 hover:shadow-md transition-all cursor-pointer`}>
                  <div className={`w-9 h-9 rounded-full bg-white flex items-center justify-center ${p.color}`}>
                    <Icon className="w-4 h-4" />
                  </div>
                  <span className="text-sm font-semibold text-slate-700">{p.name} Insurance</span>
                </Link>
              );
            })}
          </div>
        </div>

        <div className="mt-10 rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
            <div>
              <div className="text-sm font-semibold uppercase tracking-[0.3em] text-slate-500">Our Other Products</div>
              <h3 className="mt-2 text-2xl font-bold text-[#0F2A4B]">Explore more offers beyond insurance</h3>
              <p className="mt-2 text-slate-600">A curated selection of additional products and services you can discover.</p>
            </div>
          </div>
          <div className="mt-6 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
            {otherProducts.map((p) => {
              const Icon = p.icon;
              return (
                <Link to={p.to} key={p.name} className={`rounded-2xl border border-slate-100 p-5 transition-all hover:-translate-y-1 hover:shadow-md ${p.bg}`}>
                  <div className={`w-11 h-11 rounded-xl bg-white flex items-center justify-center mb-4 ${p.color}`}>
                    <Icon className="w-5 h-5" />
                  </div>
                  <div className="font-semibold text-[#0F2A4B]">{p.name}</div>
                  <div className="mt-1 text-sm text-slate-600">{p.subtitle}</div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;
